import { css } from "@emotion/css";
import { theme } from "@repo-sapiens/theme";

export const BillingStyle = css`
  width: 100%;
  margin-top: 12px;
`;
export const BillingTitleStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;

export const WalletIconStyle = {
  width: "24px",
  height: "24px",
  marginRight: "8px",
};

export const MontlyYearlyStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 16px;
  @media (max-width: 765px) {
    justify-content: center;
  }
`;
export const MontlyYearlyStyleRight = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 8px;
  @media (max-width: 765px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
export const MontlyYearlyStyleLeft = css`
  margin-right: 8px;
`;

export const PricingContainer = css`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  @media (max-width: 765px) {
    grid-template-columns: 1fr;
  }
`;
export const PricingCardStyle = (active: boolean) => css`
  width: 100%;
  height: 100%;
  border-radius: 16px;
  border: 1px solid
    ${active ? theme.colors.text["highlight/1"] : theme.colors.border.primary};
  backdrop-filter: blur(1.5px);
  position: relative;
  padding: 16px 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
export const PricingFeatureStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;
`;
export const PricingFeatureIconStyle = {
  width: "18px",
  height: "18px",
  marginRight: "8px",
};
export const SelectedTagStyle = css`
  position: absolute;
  top: 12px;
  right: 10px;
`;
export const TrialBannerStyle = css`
  position: absolute;
  top: 8px;
  right: 6px;
  border-radius: 76px;
  background: #6a53fe;
  display: inline-flex;
  padding: 8px 49px;
  justify-content: center;
  align-items: center;
`;

export const PricingFreeButtonStyle = css`
  all: unset;
  cursor: pointer;
  height: 44px;
  width: 100%;
  padding-inline: 0px;
  border-radius: 57px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  font-size: 16px;
  margin-top: 16px;
  background: transparent;
  border: 1px solid ${theme.colors.border.primary};
  color: ${theme.colors.text["text/main"]};
  &:disabled {
    cursor: not-allowed;
  }
`;

export const PricingButtonStyle = css`
  all: unset;
  cursor: pointer;
  height: 44px;
  width: 100%;
  padding-inline: 0px;
  border-radius: 57px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  color: ${theme.colors.text.dark};
  position: relative;
  overflow: hidden;
  background-color: ${theme.colors.text["highlight/3"]};
  font-size: 16px;
  margin-top: 16px;
  &:disabled {
    cursor: not-allowed;
    background: transparent;
    border: 1px solid ${theme.colors.border.primary};
    color: ${theme.colors.text["text/main"]};
  }
`;
export const ManageSubscriptionStyle = css`
  width: 100%;
  border-radius: 16px;
  border: 1px solid ${theme.colors.border.primary};
  padding: 16px 24px;
  margin-top: 34px;
`;
export const TrialEndStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  @media (max-width: 765px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
export const BillingInfoStyle = css`
  width: 100%;
`;
export const BillingInfoRootStyle = css`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 765px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
export const BillingInfoLeft = css`
  max-width: 50%;
  display: flex;
  flex-direction: row;
  @media (max-width: 765px) {
    width: 100%;
    max-width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }
`;
export const BillingInfoRight = css`
  width: 50%;
  flex-direction: row;
  justify-content: flex-end;
  display: flex;
  @media (max-width: 765px) {
    justify-content: center;
    width: 100%;
    margin-top: 24px;
  }
`;
export const BillingInfoItemStyle = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-right: 42px;
  @media (max-width: 765px) {
    margin-right: 0px;
  }
`;

export const ManageSubscriptionButtonStyle = css`
  all: unset;
  box-sizing: border-box;
  cursor: pointer;
  height: 44px;
  width: 100%;
  max-width: 250px;
  padding-inline: 0px;
  border-radius: 57px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  color: ${theme.colors.text.primary};
  position: relative;
  overflow: hidden;
  background-color: ${theme.colors.text["highlight/1"]};
  font-size: 16px;
  padding: 0px 24px;
  &:disabled {
    cursor: not-allowed;
    background: transparent;
    border: 1px solid ${theme.colors.border.primary};
    color: ${theme.colors.text["text/main"]};
  }
`;
